import React from 'react'
import { Link } from 'react-router-dom';
// import BgImage from "../images/acfan.jpg";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaHome, FaEnvelope, FaWhatsapp, FaPhone, FaPhoneAlt, FaYoutube } from "react-icons/fa";
import ContactHome from '../ContactHome';



function Contact() {
  return (
    <div className='container-fluid px-0 pt-5'>
      <div
        className="contact-banner d-flex align-items-center px-3 position-relative pb-5"
        style={{
          backgroundImage: `url(https://swastikengineers.net/static/media/acfan.ffd0da379b93a2b40ba6.jpg)`,
        }}>
        <div className="overlay"></div>
        <div className="row position-relative text-white text-center py-4">
          <h1 className="fw-bold" >Contact Us</h1>
          <p className="lead my-5"  style={{
            fontSize: "clamp(1.3rem, 2.5vw, 1rem)",
            margin: "0.5rem 0 1rem 0",
            color: "whitesmoke",
          }}>
           Get in touch with Palanhaar sanatan foundation (PSF Academy) for expert guidance and personalized learning support. We’re here to answer your questions and help you grow with knowledge, values, and Sanatan wisdom.
          </p>

          {/* Breadcrumbs */}
             {/* Breadcrumbs */}
                  <nav aria-label="breadcrumb">
                    <ol
                      style={{
                        listStyle: "none",
                        display: "flex",
                        justifyContent: "center",
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      <li style={{ marginRight: "5px" }}>
                        <Link to="/" style={{ color: "white", textDecoration: "none" }}>
                          Home
                        </Link>
                        <span style={{ margin: "0 5px" }}>/</span>
                      </li>
                      <li style={{ color: "white !important", }}>Contact Us</li>
                    </ol>
                  </nav>
        </div>
      </div>




      <div className=''>
        <ContactHome />
        <div className='text-center p-3 my-5' >
          <h2 className='fw-bold'>
            Contact Us
          </h2>
          <p>We’re here to help you find the perfect air cooling solution tailored to your needs. Whether you have questions, need a consultation, or want a custom quote, our team is ready to assist you.</p>


          <div className="row mx-0 d-flex align-items-center">
            <div className="col-12 col-sm-6">
              <div className="info d-inline">
                <p><i className="fa-solid fa-envelope text-danger my-1"></i>info@palanhaars.com/</p>
                <p><i className="fa-solid fa-envelope text-danger my-1"></i>palanhaars@gmail.com</p>
                <p><i className="fa-solid fa-location-dot text-danger my-1"></i><span><b>Head Office:-</b></span> 33-A Chand Bihari Nagar KHATIPURA JAIPUR</p>
                {/* <p><i className="fa-solid fa-location-dot text-danger my-1"></i><span><b>Branch Office:-</b></span> G1 & 2, Regent Square Mall, CP-4, Japanese Zone, Neemrana, Alwar, 301705</p> */}
                <a href="#" className="btn-consult my-1">Free Consultation</a>
              </div>
            </div>
            <div className="col-12 col-sm-6" >
              <h6 className="fw-bold mb-3">Follow Us</h6>
             <div style={{ display:'flex', gap:12, marginTop:10 }}>

    <a href="https://www.facebook.com/profile.php?id=61581221519255" target="_blank" rel="noreferrer"
      style={{
        width:38, height:38, borderRadius:'50%',
        display:'flex', alignItems:'center', justifyContent:'center',
        background:'rgba(148, 192, 28, 0.06)',
        color:'#0b138a',
        fontSize:16,
        border:'1px solid rgba(36, 20, 180, 0.15)',
        transition:'all 0.3s ease'
      }}
      onMouseEnter={e=>{
        e.currentTarget.style.transform='translateY(-4px) scale(1.08)';
        e.currentTarget.style.color='#ffcf40';
        e.currentTarget.style.background='rgba(175, 138, 26, 0.12)';
        e.currentTarget.style.boxShadow='0 6px 18px rgba(255,207,64,0.25)';
      }}
      onMouseLeave={e=>{
        e.currentTarget.style.transform='none';
        e.currentTarget.style.color='#e7f7ef';
        e.currentTarget.style.background='rgba(255,255,255,0.06)';
        e.currentTarget.style.boxShadow='none';
      }}
    >
      <FaFacebookF />
    </a>

    <a href="https://instagram.com" target="_blank" rel="noreferrer"
      style={{
        width:38, height:38, borderRadius:'50%',
        display:'flex', alignItems:'center', justifyContent:'center',
        background:'rgba(255,255,255,0.06)',
        color:'rgb(214, 68, 36)',
        fontSize:16,
        border:'1px solid rgba(64, 207, 35, 0.15)',
        transition:'all 0.3s ease'
      }}
      onMouseEnter={e=>{
        e.currentTarget.style.transform='translateY(-4px) scale(1.08)';
        e.currentTarget.style.color='#ffcf40';
        e.currentTarget.style.background='rgba(255,207,64,0.12)';
        e.currentTarget.style.boxShadow='0 6px 18px rgba(255,207,64,0.25)';
      }}
      onMouseLeave={e=>{
        e.currentTarget.style.transform='none';
        e.currentTarget.style.color='#e7f7ef';
        e.currentTarget.style.background='rgba(255,255,255,0.06)';
        e.currentTarget.style.boxShadow='none';
      }}
    >
      <FaInstagram />
    </a>

    <a href="https://www.youtube.com/@palanhaar9" target="_blank" rel="noreferrer"
      style={{
        width:38, height:38, borderRadius:'50%',
        display:'flex', alignItems:'center', justifyContent:'center',
        background:'rgba(255,255,255,0.06)',
        color:'#e7260d',
        fontSize:16,
        border:'1px solid rgba(206, 157, 12, 0.15)',
        transition:'all 0.3s ease'
      }}
      onMouseEnter={e=>{
        e.currentTarget.style.transform='translateY(-4px) scale(1.08)';
        e.currentTarget.style.color='#ffcf40';
        e.currentTarget.style.background='rgba(255,207,64,0.12)';
        e.currentTarget.style.boxShadow='0 6px 18px rgba(255,207,64,0.25)';
      }}
      onMouseLeave={e=>{
        e.currentTarget.style.transform='none';
        e.currentTarget.style.color='#e7f7ef';
        e.currentTarget.style.background='rgba(255,255,255,0.06)';
        e.currentTarget.style.boxShadow='none';
      }}
    >
      <FaYoutube />
    </a>

    <a href="https://wa.me/919214433316?text=Hello%20I%20want%20to%20know%20about%20your%20services" target="_blank" rel="noreferrer"
      style={{
        width:38, height:38, borderRadius:'50%',
        display:'flex', alignItems:'center', justifyContent:'center',
        background:'rgba(255,255,255,0.06)',
        color:'#068043',
        fontSize:16,
        border:'1px solid rgba(20, 177, 85, 0.15)',
        transition:'all 0.3s ease'
      }}
      onMouseEnter={e=>{
        e.currentTarget.style.transform='translateY(-4px) scale(1.08)';
        e.currentTarget.style.color='#ffcf40';
        e.currentTarget.style.background='rgba(255,207,64,0.12)';
        e.currentTarget.style.boxShadow='0 6px 18px rgba(255,207,64,0.25)';
      }}
      onMouseLeave={e=>{
        e.currentTarget.style.transform='none';
        e.currentTarget.style.color='#e7f7ef';
        e.currentTarget.style.background='rgba(255,255,255,0.06)';
        e.currentTarget.style.boxShadow='none';
      }}
    >
      <FaWhatsapp />
    </a>

    <a href="tel:+919214433316"
      style={{
        width:38, height:38, borderRadius:'50%',
        display:'flex', alignItems:'center', justifyContent:'center',
        background:'rgba(255,255,255,0.06)',
        color:'#0aac5b',
        fontSize:16,
        border:'1px solid rgba(145, 113, 17, 0.15)',
        transition:'all 0.3s ease'
      }}
      onMouseEnter={e=>{
        e.currentTarget.style.transform='translateY(-4px) scale(1.08)';
        e.currentTarget.style.color='#ffcf40';
        e.currentTarget.style.background='rgba(255,207,64,0.12)';
        e.currentTarget.style.boxShadow='0 6px 18px rgba(255,207,64,0.25)';
      }}
      onMouseLeave={e=>{
        e.currentTarget.style.transform='none';
        e.currentTarget.style.color='#e7f7ef';
        e.currentTarget.style.background='rgba(255,255,255,0.06)';
        e.currentTarget.style.boxShadow='none';
      }}
    >
      <FaPhoneAlt />
    </a>

  </div> 
            </div>
          </div>
        </div>

      </div>

      <div>
        <iframe className='w-100 border border-5 border-danger' style={{ height: "450px" }} src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d113905.99817304466!2d75.76258140000002!3d26.853865999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x396db39830a11dd5%3A0xf06793e74465ed48!2sVAISHNAV%20VIVEK%20VIDHYALYA%2F%20VISHV%20VIDHYALAYA%2C%2033%20A%2C%20Chand%20Bihari%20Nagar%2C%20Khatipura%2C%20Jaipur%2C%20Rajasthan%20302039!3m2!1d26.9331982!2d75.7518953!5e0!3m2!1sen!2sin!4v1776409220307!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>


    </div>
  )
}

export default Contact
